import { CheckCircle2, XCircle, Info, AlertTriangle, X } from 'lucide-react';
import { useToastStore, type ToastType } from '@/stores/toast';

const styleMap: Record<ToastType, { cls: string; Icon: typeof CheckCircle2 }> = {
  success: { cls: 'bg-success-bg border-success-border text-success-text', Icon: CheckCircle2 },
  error:   { cls: 'bg-danger-bg border-danger-border text-danger-text', Icon: XCircle },
  info:    { cls: 'bg-group-dashboard-bg border-chrome-marker text-chrome-base', Icon: Info },
  warning: { cls: 'bg-alert-bg border-alert-border text-alert-text', Icon: AlertTriangle },
};

export function Toaster() {
  const toasts = useToastStore((s) => s.toasts);
  const remove = useToastStore((s) => s.remove);

  if (toasts.length === 0) return null;

  return (
    <div
      aria-live="polite"
      className="fixed top-4 right-4 z-[100] space-y-2 max-w-md max-h-[80vh] overflow-y-auto"
    >
      {toasts.slice(-5).map((t) => {
        const { cls, Icon } = styleMap[t.type];
        const isError = t.type === 'error' || t.type === 'warning';
        return (
          <div
            key={t.id}
            role={isError ? 'alert' : 'status'}
            className={`flex items-start gap-2 px-4 py-3 rounded-lg border shadow-overlay ${cls} animate-in slide-in-from-right`}
          >
            <Icon size={20} className="shrink-0 mt-0.5" />
            <div className="flex-1 text-sm whitespace-pre-line">{t.message}</div>
            <button
              onClick={() => remove(t.id)}
              className="shrink-0 opacity-60 hover:opacity-100"
            >
              <X size={16} />
            </button>
          </div>
        );
      })}
    </div>
  );
}
